import * as React from "react";
import { Box } from "@mui/material";
import WebQuestionButton from "../../../ui-components/Buttons/WebQuestionButton";
import { submitAnswer } from "../../../../store/slices/learner";
import { useDispatch, useSelector } from "../../../../store";
import qs from "qs";
import './../../../../assets/styles/match-selection-button.css';

import WebCorrectOrder from "./web-correct-order";
import WebMatchTextSelection from "./web-match-text-selection";
import WebCalendar from "./web-calendar";
import WebMatchTextSelectionImgToTxt from "./web-match-text-selection-img-to-txt";
import WebMultipleSelect from "./web-multiple-select";
import WebCorrectOrderHoliday from "./web-correct-order-holiday";
import WebCorrectOrderTraining from "./web-correct-order-training";
import WebNewsPaperIndex from "./web-newspaper-index";
import WebSelectSVGPath from "./web-select-svg-path";
import WebDropDownSelect from "./web-drop-down-select";
import WebMatchText from "./web-match-text";
import WebSelectSVGRect from "./web-select-svg-rect";
import WebMatchTextSelectionResources from "./web-match-text-selection-resources";
import WebSelectScenarioInfo from "./web-select-scenario-info";
import WebCorrectOrderMatch from "./web-correct-order-match";
import WebCorrectOrderMatchCoin from "./web-correct-order-match-coin";
import WebMultipleSelectStore from "./web-multiple-select-store";
import WebMultipleSelectBook from "./web-multiple-select-book";
import WebMultipleSelectText from "./web-multiple-select-text";
import WebListenAndAnswer from "./web-listen-and-answer";
import WebFillInTheBlankAlphabet from "./web-fill-in-the-blank-alphabet";
import WebMultipleSelectChecklist from "./web-multiple-select-checklist";
import WebMultipleTextInputsCalendar from "./web-multiple-text-inputs-calendar";
import WebMultipleSelectTelephone from "./web-multiple-select-telephone";
import WebMultipleSelectApplication from "./web-multiple-select-application";
import WebSelectSentence from "./web-select-sentence";
import WebCorrectOrderMatchEmail from "./web-correct-order-match-email";
import WebFillInTheBlankSentence from "./web-fill-in-the-blank-sentence";
import WebMatchTextPunctuation from "./web-match-text-punctuation";
import WebMatchTextImageToTextBottom from "./web-match-text-image-to-text-bottom";
import WebCorrectOrderReport from "./web-correct-order-report";
import WebMatchSelectionDocument from "./web-match-text-selection-document";
import WebMultipleChoiceAudio from "./web-multiple-choice-audio";
import WebMultipleChoiceAudioPath from "./web-multiple-choice-audio-path";
import WebMultipleChoiceObjectAudio from "./web-multiple-choice-object-audio";
import WebMultipleChoiceAudioFactOrOpinion from "./web-multiple-choice-audio-fact-or-opinion";
import WebCorrectOrderAudioRecipe from "./web-correct-order-audio-recipe";
import WebGridChoiceAudio from "./web-grid-choice-audio";
import WebMultipleChoiceAudioRect from "./web-multiple-choice-audio-rect";
import WebEnumerate from "./web-enumerate";
import WebEnumerateTxtInImg from "./web-enumerate-txt-in-img";
import WebNumeracySelectImg from "./web-numeracy-select-img";
import WebNumeracyGraph from "./web-numeracy-graph";
import WebNumeracyArea from "./web-numeracy-area";
import WebNumeracyScenario from "./web-numeracy-scenario";
import WebNumeracyOption from "./web-numeracy-option";
import WebNumeracyFormula from "./web-numeracy-formula";
import WebNumeracyInputWithMatch from "./web-numeracy-input-with-match";
import WebMatchTextSelectionAudioSentence from "./web-match-text-selection-audio-sentence";
import WebMatchSelectionShapeText from "./web-match-selection-shape-text";
import WebMultipleSelectionOption from "./web-multiple-selection-option";
import WebSelectSentenceBox from "./web-select-sentence-box";
import WebSelectStory from "./web-select-story";
import WebSelectTextSquare from "./web-select-text-square";
import WebNumeracySelectText from "./web-numeracy-select-text";
import WebNumeracySelectFraction from "./web-numeracy-select-fraction";
import WebNumeracyInputText from "./web-numeracy-input-text";
import WebMatchTextImageBottomColumn from "./web-match-text-image-bottom-column";
import WebSelectOptionsColumn from "./web-select-options-column";
import WebNumeracySelectMetric from "./web-numeracy-select-metric";
import WebSelectTextImageLeft from "./web-select-text-image-left";
import WebEquivalentAmountSelection from "./web-equivalent-amount-selection";

export default function WebQuestionRenderer({
  question,
  nextQuestion = () => {},
}) {
    const dispatch = useDispatch();
    const questionData = question?.questionData || {};
    const [proceed, setProceed] = React.useState(false);
    const [answer, setAnswer] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    // const [bodyOverflow, setBodyOverflow] = React.useState(true);
    const ref = React.useRef();
    const [startTime, setStartTime] = React.useState(Date.now());
    const learner = useSelector((state) => state.learner || {}); 

    const { invite } = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    });

    React.useEffect(() => {
        setProceed(false);
        ref.current.scrollTop = 0;
        setStartTime(Date.now());
    }, [question]);

    const handleOnAnswer = (data) => {
        setProceed(data?.canProceed || false);
        setAnswer(data?.answer || null);
    };

    const handleSubmitAnswer = async () => {
        setIsLoading(true);
        const nextQuestionId = await dispatch(
            submitAnswer(question, answer, startTime, invite)
        );
        nextQuestion(nextQuestionId);
        // setIsLoading(nextQuestionId !== "false");
        setIsLoading(false);
    };

    const renderQuestionComponent = () => {
        const componentMap = {
            "correct-order": WebCorrectOrder,
            "match-text-selection": WebMatchTextSelection,
            "match-text-selection-img-to-txt": WebMatchTextSelectionImgToTxt,
            "calendar": WebCalendar,
            "multiple-select": WebMultipleSelect,
            "correct-order-holiday": WebCorrectOrderHoliday,
            "correct-order-training": WebCorrectOrderTraining,
            "newspaper-index": WebNewsPaperIndex,
            "select-svg-path": WebSelectSVGPath,
            "drop-down-select": WebDropDownSelect,
            "match-text": WebMatchText,
            "select-svg-rect": WebSelectSVGRect,
            "match-text-selection-resources": WebMatchTextSelectionResources,
            "select-scenario-info": WebSelectScenarioInfo,
            "correct-order-match": WebCorrectOrderMatch,
            "correct-order-match-coin": WebCorrectOrderMatchCoin,
            "multiple-select-store": WebMultipleSelectStore,
            "multiple-select-book": WebMultipleSelectBook,
            "multiple-select-text": WebMultipleSelectText,
            "listen-and-answer": WebListenAndAnswer,
            "fill-in-the-blank-alphabet": WebFillInTheBlankAlphabet,
            "multiple-select-checklist": WebMultipleSelectChecklist,
            "multiple-text-inputs-calendar": WebMultipleTextInputsCalendar,
            "multiple-select-telephone": WebMultipleSelectTelephone,
            "multiple-select-application": WebMultipleSelectApplication,
            "select-sentence": WebSelectSentence,
            "correct-order-match-email": WebCorrectOrderMatchEmail,
            "fill-in-the-blank-sentence": WebFillInTheBlankSentence,
            'match-text-punctuation': WebMatchTextPunctuation,
            "match-text-image-to-text-bottom": WebMatchTextImageToTextBottom,
            "correct-order-report": WebCorrectOrderReport,
            "match-text-selection-document": WebMatchSelectionDocument,
            "multiple-choice-audio": WebMultipleChoiceAudio,
            "multiple-choice-audio-path": WebMultipleChoiceAudioPath,
            "multiple-choice-object-audio": WebMultipleChoiceObjectAudio,
            "multiple-choice-audio-fact-or-opinion": WebMultipleChoiceAudioFactOrOpinion,
            "correct-order-audio-recipe": WebCorrectOrderAudioRecipe,
            "grid-choice-audio": WebGridChoiceAudio,
            "multiple-choice-audio-rect": WebMultipleChoiceAudioRect,
            "enumerate": WebEnumerate,
            "enumerate-txt-in-img": WebEnumerateTxtInImg,
            "numeracy-select-img": WebNumeracySelectImg,
            "numeracy-graph": WebNumeracyGraph,
            "numeracy-area": WebNumeracyArea,
            "numeracy-scenario": WebNumeracyScenario,
            "numeracy-option": WebNumeracyOption,
            "numeracy-formula": WebNumeracyFormula,
            "numeracy-input-with-match": WebNumeracyInputWithMatch,
            "match-text-selection-audio-sentence": WebMatchTextSelectionAudioSentence,
            "match-selection-shape-text": WebMatchSelectionShapeText,
            "multiple-selection-option": WebMultipleSelectionOption,
            "select-sentence-box": WebSelectSentenceBox,
            "select-story": WebSelectStory,
            "select-text-square": WebSelectTextSquare,
            "numeracy-select-text": WebNumeracySelectText,
            "numeracy-select-fraction": WebNumeracySelectFraction,
            "numeracy-input-text": WebNumeracyInputText,
            "match-text-image-bottom-column": WebMatchTextImageBottomColumn,
            "select-options-column": WebSelectOptionsColumn,
            "numeracy-select-metric": WebNumeracySelectMetric,
            "select-text-image-left": WebSelectTextImageLeft,
            "equivalent-amount-selection": WebEquivalentAmountSelection,
        };

        let questionType = questionData.questionType;
        if (learner?.details?.testLevel === "acsf4") {
            questionType = questionData?.acsf4?.questionType;
        } else if (learner?.details?.testLevel === "vfh") {
            questionType = questionData?.vfh?.questionType;
        }

        const Component = componentMap[questionType];
        return Component ? (
        <Component
            question={questionData}
            onAnswer={handleOnAnswer}
            // onDrag={setBodyOverflow}
        />
        ) : null;
    };

    return (
        <React.Fragment>
            <Box
                ref={ref}
                sx={{
                    display: "flex",
                    position: "relative",
                    backgroundColor: "white",
                    overflow: "hidden",
                    flexGrow: "1",
                }}
            >
                <Box sx={{
                    position: "relative",
                    display: "flex",
                    flexGrow: "1",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    userSelect: "none",
                    overflowY: "auto",
                    maxHeight: "96%",
                }}>
                    {renderQuestionComponent()}
                </Box>
            </Box>
            {(proceed || isLoading) &&
                <WebQuestionButton
                    title="Next"
                    disabled={!proceed}
                    loading={isLoading}
                    loadingMessage="Submitting.."
                    handleClick={handleSubmitAnswer}
                />  
            }
        </React.Fragment>
    );
}